<template>
    <div class="text-black  font-normal italic ">

        <span :class="isMobile ? 'text-xs pr-1' : 'text-sm pr-1'" v-if="dataAtual">

            {{ dataAtual }}
        </span>
        <!-- <div class="tooltip tooltip-bottom " :data-tip="weather?.temperatura_descricao || 'Temperatura indisponível'">
            {{ formattedTemperature }}
        </div>
        &nbsp;
        <div class="tooltip tooltip-bottom" :data-tip="weather?.descricao || 'Clima não informado'">
            {{ weatherEmoji }}
        </div> -->
    </div>
</template>


<script setup>
import { computed } from 'vue'
import { usePage, router } from '@inertiajs/vue3'

const page = usePage()

const dataAtual = computed(() => page.props.data_atual_por_extenso || '')

const props = defineProps({
    weather: {
        type: Object,
        default: () => ({
            temperatura: null,
            cidade: '',
            icone: null,
            descricao: null,
            temperatura_descricao: null,
        })
    },
    isMobile: {
        type: Boolean,
        default: false,
    }
})

const weatherEmoji = computed(() => {
    const iconUrl = props.weather?.icone
    if (!iconUrl) return '☁️'

    const icon = iconUrl
        .replace('https://cdn.meteoblue.com/website/images/icons/', '')
        .replace('.svg', '')
        .trim()

    const emojis = {
        'clear-day': '☀️',
        'clear-night': '🌙',
        'partly-cloudy-day': '🌤️',
        'partly-cloudy-night': '☁️',
        'cloudy': '☁️',
        'fog': '🌫️',
        'wind': '💨',
        'snow': '❄️',
        'sleet': '🌨️',
        'rain': '🌧️',
        'showers-day': '🌦️',
        'showers-night': '🌧️',
        'thunderstorm': '⛈️',
        'hail': '🧊',
    }

    return emojis[icon] || '☁️'
})

const formattedTemperature = computed(() => {
    const t = props.weather?.temperatura
    return typeof t === 'number' ? `${t.toFixed(1)}°` : '--°'
})

const cityName = computed(() => {
    const cidade = props.weather?.cidade
    return cidade ? cidade.replace('-PI', '').trim() : ''
})
</script>
